import { render, staticRenderFns } from "./RecruitBanner.vue?vue&type=template&id=6a824f9c&"
import script from "./RecruitBanner.vue?vue&type=script&lang=js&"
export * from "./RecruitBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/circleci/project/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
installComponents(component, {VCard,VImg})
